import { MIN_INDEX_FOR_SECOND_ROW } from '@yme/components/HomePage/components/constants';
import { infiniteDesktopSizeMap, LogoIconSize, tabletSizeMap, UPCOMING_EVENTS_MAX_CARD, } from './constants';
export function isUpcomingEventsEmpty(props) {
    return !props.upcomingEvents || props.upcomingEvents.length === 0;
}
export const calcMarginBottom = ({ length, isMobileView, isTabletView, isInfiniteDesktopView, index, }) => {
    const currentPosition = index + 1;
    const isMarginForDesktop = isInfiniteDesktopView &&
        length === UPCOMING_EVENTS_MAX_CARD &&
        currentPosition < MIN_INDEX_FOR_SECOND_ROW;
    const isMarginForTablet = isTabletView &&
        length >= UPCOMING_EVENTS_MAX_CARD - 1 &&
        currentPosition < MIN_INDEX_FOR_SECOND_ROW;
    const isMarginForMobile = isMobileView && currentPosition <= length - 1;
    if (isMarginForDesktop || isMarginForTablet || isMarginForMobile) {
        return '24px';
    }
    return 'auto';
};
export const getLogoMaxHeight = ({ eventCardsLength, isInfiniteDesktopView, isTabletView, }) => {
    if (isInfiniteDesktopView) {
        return infiniteDesktopSizeMap[eventCardsLength] ?? LogoIconSize.SMALL;
    }
    if (isTabletView) {
        return tabletSizeMap[eventCardsLength] ?? LogoIconSize.SMALL;
    }
    return LogoIconSize.SMALL;
};
